import { AlertCircleIcon, HomeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '../components/ui/button';

/**
 * Render a component for the "Not Found" page.
 *
 * @return {JSX.Element} The component for the "Not Found" page.
 */
export const NotFound = () => {
  return (
    <div className="flex min-h-[100svh] w-full flex-col items-center justify-center">
      <AlertCircleIcon className="mb-4 h-40 w-40" />
      <h1 className="py-6 text-3xl">Ocorreu um erro...</h1>

      <Link to="/">
        <Button variant="link">
          <HomeIcon className="mr-2 size-4" />
          Carregue aqui para voltar à página inicial
        </Button>
      </Link>
    </div>
  );
};
